module.exports = __webpack_public_path__ + "6b707c61/img/cadBim.e369a02a.png";